import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { RefreshCw, Wallet } from "lucide-react";
import { API, authHeader } from "@/lib/api";

const PLAN_LABEL = { "1m": "1 Bulan", "3m": "3 Bulan", "12m": "1 Tahun" };
const fmtRp = (n) => `Rp${Number(n || 0).toLocaleString("id-ID")}`;

const Card = ({ label, value, cls = "text-white", testid }) => (
  <div className="border border-white/10 bg-ink-surface px-4 py-3" data-testid={testid}>
    <div className="font-mono text-[9px] uppercase tracking-widest text-mute-dim">{label}</div>
    <div className={`mt-1 font-display text-xl font-black ${cls}`}>{value}</div>
  </div>
);

export const AdminPayments = () => {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    const { data } = await axios.get(`${API}/admin/payments`, { headers: authHeader() });
    setData(data);
  }, []);

  useEffect(() => { load().catch(() => toast.error("Gagal memuat pembayaran")); }, [load]);

  if (!data) return <p className="py-10 text-center font-mono text-xs text-mute-dim">memuat pembayaran...</p>;

  return (
    <div data-testid="admin-payments">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">
          <Wallet size={12} className="text-buy" /> Riwayat Pembayaran — tercatat otomatis saat user ditandai berbayar
        </p>
        <button onClick={load} data-testid="payments-refresh"
          className="flex items-center gap-2 border border-white/20 px-3 py-1.5 font-mono text-[10px] text-mute transition-colors hover:text-white">
          <RefreshCw size={12} /> MUAT ULANG
        </button>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-3">
        <Card label="Total Pemasukan" value={fmtRp(data.total_all)} cls="text-buy" testid="pay-total-all" />
        <Card label="Pemasukan Bulan Ini" value={fmtRp(data.total_month)} cls="text-[#8b97f5]" testid="pay-total-month" />
        <Card label="Jumlah Transaksi" value={data.count} testid="pay-count" />
      </div>

      <div className="mt-4 overflow-x-auto border border-white/10">
        <table className="w-full min-w-[720px] text-left font-mono text-xs" data-testid="payments-table">
          <thead>
            <tr className="border-b border-white/10 bg-ink-surface text-[9px] uppercase tracking-widest text-mute-dim">
              <th className="px-4 py-3">Tanggal</th><th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Paket</th><th className="px-4 py-3">Harga</th>
              <th className="px-4 py-3">Berlaku s/d</th><th className="px-4 py-3">Dicatat oleh</th>
            </tr>
          </thead>
          <tbody>
            {data.items.length === 0 ? (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-mute-dim">
                belum ada pembayaran tercatat — tandai user berbayar lewat tombol EDIT di Monitoring
              </td></tr>
            ) : (
              data.items.map((p) => (
                <tr key={p.id} className="border-b border-white/5 transition-colors hover:bg-white/[0.03]">
                  <td className="px-4 py-2.5 text-mute">{p.created_at?.slice(0, 16).replace("T", " ")}</td>
                  <td className="px-4 py-2.5">
                    <span className="text-white">{p.user_name || "—"}</span>
                    <span className="block text-[10px] text-mute-dim">{p.user_email}</span>
                  </td>
                  <td className="px-4 py-2.5 text-mute">{PLAN_LABEL[p.plan] || p.plan}</td>
                  <td className="px-4 py-2.5">
                    <span className="font-bold text-buy">{fmtRp(p.price)}</span>
                    {p.price < p.list_price && (
                      <span className="block text-[9px] text-warn">diskon dari {fmtRp(p.list_price)}</span>
                    )}
                  </td>
                  <td className="px-4 py-2.5 text-mute-dim">{p.expires?.slice(0, 10)}</td>
                  <td className="px-4 py-2.5 text-mute-dim">{p.recorded_by}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
